export default function (obj, path, value){
  let r = obj;
  for(let a = 0; a < path.length - 1; a++){
    if(r[path[a]]===undefined) r[path[a]] = {};
    r = r[path[a]];
  }
  r[path[path.length - 1]] = value;
  return r;
}